import { clsx } from '@eduzz/houston-styles';
import CheckIcon from '@material-ui/icons/CheckCircle';
import { useFormikContext } from 'formik';
import * as React from 'react';

import { STEP_ITEM_HEIGHT, useStyles } from './styles';
import { useStepper } from '../context';

const steps = ['Dados bancários', 'Documentos', 'Comprovante', 'Resumo', 'Verificação'];

function Wizard() {
  const classes = useStyles();
  const { currentStep, goToStep } = useStepper();
  const formik = useFormikContext();

  function handleDoneClick(stepPosition: number) {
    goToStep(stepPosition);
  }

  const hasStepsFinished = currentStep > steps.length;
  const offsetMultiplier = (hasStepsFinished ? steps.length : currentStep) - 1;
  const positionIndicatorTopOffset = STEP_ITEM_HEIGHT * offsetMultiplier;

  return (
    <aside className={classes.root}>
      <nav>
        <span
          className={hasStepsFinished ? '--finished' : ''}
          role='presentation'
          aria-valuenow={currentStep}
          style={{ top: positionIndicatorTopOffset }}
        />
        <ol>
          {steps.map((step, index) => {
            const position = index + 1;
            const isDone = currentStep > position;
            const isCurrent = currentStep === position;
            const isNext = currentStep < position;
            return (
              <li
                key={step}
                className={clsx(classes.item, isDone && '--done', isCurrent && '--current', isNext && '--next')}
                {...(isDone && { onClick: () => handleDoneClick(position) })}
              >
                <button id={`step-nav-btn-${position}`} disabled={formik?.isSubmitting}>
                  <CheckIcon className={clsx(classes.doneIcon, isDone && '--shown')} />
                  {step}
                </button>
              </li>
            );
          })}
        </ol>
      </nav>
    </aside>
  );
}

export { Wizard };
